<template>
  <v-container>
    <template>
      <v-row>
        <v-col cols="12" md="4">
          <span class="align-center">
            Grupos
          </span>
        </v-col>
        <v-col cols="12" md="4">
          <!-- <v-autocomplete
            v-model="value"
            :items="itemsFiltro"
            outlined
            dense
            label="Filtrar por..."
            @change="selectFiltro()"
          ></v-autocomplete> -->
        </v-col>
        <v-col cols="12" md="4">
          <v-btn color="primary" dark class="mb-2" @click="nuevo">Nuevo</v-btn>
        </v-col>
      </v-row>
    </template>
    <Table
      @edit="editClick"
      @delete="eliminarClick"
      @detalle="detalleClick"
      @act="activarDesactivar"
      :headers="headers"
      :arrayList="grupos"
      :opciones="true"
      :title="gruposStr"
    />
    <Dialog
      :show="adDialog"
      :object="objAction"
      @activate="activar"
      @deactivate="desactivar"
      @delete="eliminar"
      @close="close"
    />
    <Modal
      @save="guardar"
      @close="close"
      :object="itemAct"
      :update="update"
      :detalle="detalle"
      :show="abrirModal"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Table from "@/components/base/Table.vue";
import Modal from "@/components/base/modal/ModalGrupo.vue";
import Dialog from "@/components/base/Dialog";
import Headers from "../headers";

export default {
  data() {
    return {
      headers: Headers.headersGrupos,
      gruposStr: "Grupos",
      modoChart: "column",
      abrirModal: false,
      itemAct: {
        nombre: null,
        descripcion:null,
        imagen: null,
        valor_franquicia: null,
        valor_deposito: null,
      },
      update: false,
      detalle: false,
      adDialog: false,
      objAction: {
        element: 'Grupo',
        adAccion: 0,
        adId: "",
        adNombre: "",
        obj: {}
      },
    };
  },
  components: {
    Table,
    Modal,
    Dialog,
  },
  async created() {
    this.llamarGrupos();

    // this.calcularDeuda();
  },
  computed: {
    ...mapState("usuarioNamespace", ["token", "usuario"]),
    ...mapState("grupoNamespace", ["grupos", "grupo"]),
  },
  methods: {
    ...mapActions("grupoNamespace", [
      "saveGrupo",
      "getGrupos",
      "updateGrupo",
      "activateGrupo",
      "deactivateGrupo",
      "deleteGrupo",
    ]),
    llamarGrupos() {
      let Token = this.token;
      this.getGrupos(Token);
    },
    editClick(obj) {
      debugger;
      this.update = true;
      this.itemAct = obj;
      this.abrirModal = true;
    },
    eliminarClick(obj) {
      this.adDialog = true;
      this.objAction.adAccion = 3;
      this.objAction.adId = obj.id;
      this.objAction.obj = obj
    },
    detalleClick(obj) {
      debugger;
      this.detalle = true;
      this.itemAct = obj;
      this.abrirModal = true;
    },
    activarDesactivar(accion, item) {
      debugger
      this.objAction.adNombre = item.nombre;
      this.objAction.adId = item.id;
      if (accion == 1) {
        this.objAction.adAccion = 1; //"Activar Grupo"
        this.adDialog = true;
      } else if (accion == 2) {
        this.objAction.adAccion = 2; //"Desactivar Grupo"
        this.adDialog = true;
      } else {
        this.adDialog = false;
      }
    },
    nuevo() {
      this.update = false;
      this.detalle = false;
      this.abrirModal = true;
    },
    guardar(obj) {
      debugger;
      if (this.update) {
        this.updateGrupo({
          token: this.token,
          usuario: this.usuario._id,
          obj: obj,
        });
      } else {
        this.saveGrupo({
          token: this.token,
          usuario: this.usuario._id,
          obj: obj,
        });
      }
      this.close();
      this.getGrupos();
    },
    activar(id) {
      debugger;
      this.activateGrupo({
        token: this.token,
        id: id,
      });
      this.close();
    },
    desactivar(id) {
      debugger
      this.deactivateGrupo({
        token: this.token,
        id: id,
      });
      this.close();
    },
    eliminar(id) {
      this.deleteGrupo({
        token: this.token,
        id: id,
      });
      this.close();
    },
    close() {
      this.detalle = false;
      this.update = false;
      this.itemAct = {}
      this.adDialog = false;
      this.abrirModal = false;
    },
  },
};
</script>
